
import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Game } from '../../../Core'

const LastTurnPopup = ({ removePopup }) => (
  <div className="popup--game">
    <div className="popup--box">
      <div className="popup--box__canvas">
        <div className="popup--heading">
          <FormattedMessage id={'popups.lastTurn.title'} />
        </div>
        <div className="popup--text">
          <FormattedMessage id={'popups.lastTurn.text'} />
        </div>
        <div className="popup--buttons">
          <div onClick={() => removePopup('last_turn_popup')} className="btn--shape shape--blue">
            <div className="btn--shape__canvas">
              <FormattedMessage id={'popups.accept'} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const mapDispatchToProps = (dispatch) => {
  return {
    removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
  }
}

LastTurnPopup.propTypes = {
  removePopup: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(LastTurnPopup))
